export const KeyKind = Symbol("@ndn/keychain#KeyKind");
export var CryptoAlgorithm;
(function (CryptoAlgorithm) {
    /** Determine whether `algo` is an asymmetric algorithm. */
    function isAsym(algo) {
        const t = algo;
        return Array.isArray(t.keyUsages.private) && Array.isArray(t.keyUsages.public);
    }
    CryptoAlgorithm.isAsym = isAsym;
    /** Determine whether `algo` is a symmetric algorithm. */
    function isSym(algo) {
        const t = algo;
        return Array.isArray(t.keyUsages.secret);
    }
    CryptoAlgorithm.isSym = isSym;
    /** Determine whether `algo` is a signing algorithm. */
    function isSigning(algo) {
        const t = algo;
        return typeof t.sigType === "number" &&
            typeof t.makeLLSign === "function" &&
            typeof t.makeLLVerify === "function";
    }
    CryptoAlgorithm.isSigning = isSigning;
    /** Determine whether `algo` is an encryption algorithm. */
    function isEncryption(algo) {
        const t = algo;
        return typeof t.makeLLEncrypt === "function" &&
            typeof t.makeLLDecrypt === "function";
    }
    CryptoAlgorithm.isEncryption = isEncryption;
})(CryptoAlgorithm || (CryptoAlgorithm = {}));
